import platformTransformers from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/services/transformer/platform-transformers.tsx';
import { getRequestFieldCategoryId } from '../../../constants.tsx';

/**
 * Transform category strings used within layout item categories and {@link FieldOperations#categoriesWhitelist} into a
 * SWIFT compatible {@link FieldCategory}.
 * Transforms {@constant REQUEST_PORTAL} in layout {@constant ISSUE_VIEW} to {@constant request} to be compatible
 * with CMP experience, and {@link FieldOperations#categoriesWhitelist}.
 */
export const jsmTmpTransformCategory: typeof platformTransformers.category = (
	containerType: string,
) => {
	if (containerType === 'REQUEST_PORTAL') {
		// `ISSUE_VIEW` layout returns request field container `REQUEST_PORTAL`
		// for `request` fields.
		// Transform to `request` so it matches
		return getRequestFieldCategoryId();
	}
	return platformTransformers.category(containerType);
};
